// Seed backend-autogenerated fields on init so the user sees the value in the
// row and can override. Currently: `trade_id` — 8-char hex derived from
// sibling `trade_name` if usable, else random.

export function generateTradeId(tradeName?: unknown): string {
  const length = 8;
  if (typeof tradeName === "string" && tradeName.trim().length > 0) {
    const slug = tradeName.toLowerCase().replace(/[^a-f0-9]/g, "");
    if (slug.length >= length) return slug.slice(0, length);
  }
  const chars = "abcdef0123456789";
  let out = "";
  for (let i = 0; i < length; i += 1) {
    out += chars[Math.floor(Math.random() * chars.length)];
  }
  return out;
}

function isEmpty(v: unknown): boolean {
  return v === undefined || v === null || v === "";
}

function schemaHasProperty(schema: any, key: string): boolean {
  if (!schema || typeof schema !== "object") return false;
  return Boolean(schema.properties && typeof schema.properties === "object" && key in schema.properties);
}

function seedObject(schema: any, data: Record<string, unknown>): Record<string, unknown> {
  if (!schema || typeof schema !== "object") return data;
  let out = data;

  if (schemaHasProperty(schema, "trade_id") && isEmpty(out.trade_id)) {
    out = { ...out, trade_id: generateTradeId(out.trade_name) };
  }

  const props = (schema.properties ?? {}) as Record<string, any>;
  for (const [key, propSchema] of Object.entries(props)) {
    const value = out[key];
    if (Array.isArray(propSchema?.oneOf) && propSchema.oneOf.length > 0 && value && typeof value === "object" && !Array.isArray(value)) {
      const branch = propSchema.oneOf.find((b: any) => {
        const bProps = b?.properties ?? {};
        for (const [k, v] of Object.entries(bProps) as any[]) {
          if (v?.const !== undefined && (value as any)[k] === v.const) return true;
        }
        return false;
      }) ?? propSchema.oneOf[0];
      const seeded = seedObject(branch, value as Record<string, unknown>);
      if (seeded !== value) out = { ...out, [key]: seeded };
    } else if (propSchema?.properties && value && typeof value === "object" && !Array.isArray(value)) {
      const seeded = seedObject(propSchema, value as Record<string, unknown>);
      if (seeded !== value) out = { ...out, [key]: seeded };
    }
  }

  return out;
}

export function seedGeneratedFields(schema: any, data: any): any {
  if (!data || typeof data !== "object" || Array.isArray(data)) return data;
  return seedObject(schema, data as Record<string, unknown>);
}
